module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/User-folder-7c79a9c814863a01cff07ac77fe3d21d.svg";